export const CLIENTES_LOADING = "CLIENTES_LOADING";
export const CLIENTES_DATA = "CLIENTES_DATA";

export const CLIENTES_DATA_PAGE = "CLIENTES_DATA_PAGE";
export const CLIENTES_DATA_PER_PAGE = "CLIENTES_DATA_PER_PAGE";
export const CLIENTES_DATA_TOTAL = "CLIENTES_DATA_TOTAL";
